require('./tab-panel.tag');

riot.tag2('tabs-content', '<yield></yield>', '', '', function(opts) {
    var self = this;
    this.on('update', function onMount() {
      var i;
      var panels = self.tags['tab-panel'];
      var panelsLength;
      var panelsArray = [];
      if (panels) {
        panelsLength = panels.length ? panels.length : 1;
        if (panelsLength === 1) {
          panelsArray.push(panels);
        } else {
          panelsArray = panels;
        }
        for (i = 0; i < panelsLength; i++) {
          if (panelsArray[i].opts.dataTab === self.parent.selectedTab) {
            panelsArray[i].root.classList.add('is-active');
          } else {
            panelsArray[i].root.classList.remove('is-active');
          }
        }
      }
    });
});
